import { IDefineCommand } from 'core-ts-types';
import { AccountModel } from 'data-ng-authentication';
import * as _4 from 'lodash4';
import { IDatasource } from 'utility-ts-orm';
import { Survey } from '../builders/survey_builder';

angular
  .module('capability-ng-survey')
  .service(
    'loadActiveSurveysCommand',
    (
      $http: ng.IHttpService,
      defineCommandORM: IDefineCommand,
      ngSurveyDatastore: IDatasource<Survey>,
      accountModel: AccountModel,
      log: any
    ) => {
      return defineCommandORM(
        'loadActiveSurveysCommand',
        (deferred: ng.IDeferred<Survey[]>, quickPoll: boolean = false) => {
          let url = `students/${accountModel.student_id}/surveys`;
          if (quickPoll) {
            url += '/?survey__quick_poll=True';
          }
          $http
            .get(url)
            .then(({ data: { data } }: { data: { data: Survey[] } }) => {
              ngSurveyDatastore.clear().write(data);
              deferred.resolve(data);
            })
            .catch((error) => {
              log.issue('Failed to load active surveys!');
              deferred.reject(error);
            });
        }
      );
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-survey/src/commands/load_active_surveys_command.ts